"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoBoneProcessStatusResponseT = exports.AutoBoneProcessStatusResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const auto_bone_process_type_js_1 = require("../../solarxr-protocol/rpc/auto-bone-process-type.js");
class AutoBoneProcessStatusResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsAutoBoneProcessStatusResponse(bb, obj) {
        return (obj || new AutoBoneProcessStatusResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsAutoBoneProcessStatusResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new AutoBoneProcessStatusResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    processType() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : auto_bone_process_type_js_1.AutoBoneProcessType.NONE;
    }
    /**
     * The current count. This value is -1 if there is nothing to report.
     */
    current() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    /**
     * The total count. This value is -1 if there is nothing to report.
     */
    total() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    /**
     * True if the operation has completed with any result, successful or not.
     */
    completed() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    /**
     * True if the completed operation was successful, only observe if `completed` is true.
     */
    success() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    /**
     * The time remaining in seconds. This value is -1 if there is nothing to report.
     */
    eta() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    static startAutoBoneProcessStatusResponse(builder) {
        builder.startObject(7);
    }
    static addProcessType(builder, processType) {
        builder.addFieldInt8(0, processType, auto_bone_process_type_js_1.AutoBoneProcessType.NONE);
    }
    static addCurrent(builder, current) {
        builder.addFieldInt32(2, current, 0);
    }
    static addTotal(builder, total) {
        builder.addFieldInt32(3, total, 0);
    }
    static addCompleted(builder, completed) {
        builder.addFieldInt8(4, +completed, +false);
    }
    static addSuccess(builder, success) {
        builder.addFieldInt8(5, +success, +false);
    }
    static addEta(builder, eta) {
        builder.addFieldFloat32(6, eta, 0.0);
    }
    static endAutoBoneProcessStatusResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createAutoBoneProcessStatusResponse(builder, processType, current, total, completed, success, eta) {
        AutoBoneProcessStatusResponse.startAutoBoneProcessStatusResponse(builder);
        AutoBoneProcessStatusResponse.addProcessType(builder, processType);
        AutoBoneProcessStatusResponse.addCurrent(builder, current);
        AutoBoneProcessStatusResponse.addTotal(builder, total);
        AutoBoneProcessStatusResponse.addCompleted(builder, completed);
        AutoBoneProcessStatusResponse.addSuccess(builder, success);
        AutoBoneProcessStatusResponse.addEta(builder, eta);
        return AutoBoneProcessStatusResponse.endAutoBoneProcessStatusResponse(builder);
    }
    unpack() {
        return new AutoBoneProcessStatusResponseT(this.processType(), this.current(), this.total(), this.completed(), this.success(), this.eta());
    }
    unpackTo(_o) {
        _o.processType = this.processType();
        _o.current = this.current();
        _o.total = this.total();
        _o.completed = this.completed();
        _o.success = this.success();
        _o.eta = this.eta();
    }
}
exports.AutoBoneProcessStatusResponse = AutoBoneProcessStatusResponse;
class AutoBoneProcessStatusResponseT {
    constructor(processType = auto_bone_process_type_js_1.AutoBoneProcessType.NONE, current = 0, total = 0, completed = false, success = false, eta = 0.0) {
        this.processType = processType;
        this.current = current;
        this.total = total;
        this.completed = completed;
        this.success = success;
        this.eta = eta;
    }
    pack(builder) {
        return AutoBoneProcessStatusResponse.createAutoBoneProcessStatusResponse(builder, this.processType, this.current, this.total, this.completed, this.success, this.eta);
    }
}
exports.AutoBoneProcessStatusResponseT = AutoBoneProcessStatusResponseT;
